import { Component, OnInit, Directive } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { AppService } from "src/app/app.service";
import { Global } from "../../../global";
import { Subject } from "rxjs";

@Component({
  selector: "app-datepicker-modal",
  templateUrl: "./mediaSelection-modal.page.html",
  styleUrls: ["./mediaSelection-modal.page.scss"],
})
export class MediaSelectionModalPage implements OnInit {
  callingFilter: string;
  User_GUID: string;
  Vendor_GUID: string;
  mediaSelectionList: any = [];
  mediaSelectionSelectedList: any;
  loadingDone: boolean = false;
  searchText: string = "";
  mediaTypeSelected: string = "Pictures";
  skip: any = 0;
  take: any = 30;

  constructor(
    public modalController: ModalController,
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private formBuilder: FormBuilder,
    private appservice: AppService,
    public globals: Global
  ) { }

  ngOnInit() {
    this.callingFilter = this.navParams.data.paramObject.callingFilter;
    this.User_GUID = this.navParams.data.paramObject.User_GUID;
    this.Vendor_GUID = this.navParams.data.paramObject.Vendor_GUID;

    this.GetMediaSelectionList();
  }

  async onMediaSelectionSelect(event: any, mediaSelection: any) {
    await this.modalCtrl.dismiss(mediaSelection);
  }

  GetMediaSelectionList() {
    var subject = new Subject<any>();

    const formData: FormData = new FormData();

    formData.append("GUID", this.globals.XRSUser.GUID);
    formData.append("search", this.searchText);
    formData.append("type", this.mediaTypeSelected);
    formData.append("filter", "AllMedia");
    formData.append("sort", "Created");
    formData.append("skip", "" + this.skip);
    formData.append("take", "" + this.take);

    this.appservice.GetMediaList(formData).subscribe((res) => {
      try {
        this.loadingDone = true;
        var returnedItems = JSON.parse(res.toString());

        if (this.mediaSelectionList.length == 0) {
          this.mediaSelectionList = returnedItems;
        } else {
          this.mediaSelectionList =
            this.mediaSelectionList.concat(returnedItems);
        }
      } catch (e) { }
    });

    return subject.asObservable();
  }

  setMediaTypeSelected(mediaTypeSelected: any) {
    this.clearList();
    this.mediaTypeSelected = mediaTypeSelected;
    this.GetMediaSelectionList();
  }

  async closeModal() {
    await this.modalCtrl.dismiss(this.mediaSelectionSelectedList);
  }

  async onCloseUpload() {
    await this.modalCtrl.dismiss(this.mediaSelectionSelectedList);
  }

  clearList() {
    this.mediaSelectionList = [];
    this.skip = 0;
    this.take = 30;
  }

  loadMoreData(event: any) {
    this.skip += this.take;
    this.GetMediaSelectionList();
    event.target.complete();
  }

  show() {
    var paramObject = {
      callingFilter: "",
      User_GUID: "",
    };

    // const modal = await this.modalController.create({
    //   component: MediaSelectionModalPage,
    //   componentProps: {
    //     paramObject: paramObject,
    //   },
    //   cssClass: 'modal-fullscreen',
    // });

    // modal.onDidDismiss().then((dataReturned) => {
    //   if (dataReturned !== null && dataReturned.data !== undefined) {
    //     let res = dataReturned.data;

    //     var found = false;
    //     this.Lesson.children
    //       .find((x) => x.GUID == this.menuOptionTreeModule.GUID)
    //       .children.find((y) => y.GUID == this.menuOptionTreeScene.GUID)
    //       .children.push(res);
    //   }
    // });
    // return await modal.present();
    {
      var promise = new Promise(async (resolve, reject) => {
        var paramObject = {
          // modalType: modalType.toLowerCase(),
          // modalHeaderText: modalHeaderText,
          // modalBodyText: modalBodyText,
        };

        const modal = await this.modalController.create({
          component: MediaSelectionModalPage,
          componentProps: {
            paramObject: paramObject,
          },
          cssClass: "modals",
        });

        modal.onDidDismiss().then(async (dataReturned) => {
          resolve(dataReturned);
        });
        modal.present();
      });
      return promise;
    }
  }
}
